var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitybuildingsIcnWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "City Buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 3C11.0511 3.00002 10.8603 3.07904 10.7197 3.21969C10.579 3.36034 10.5 3.55109 10.5 3.75V6H5.25C5.05109 6.00002 4.86034 6.07904 4.71969 6.21969C4.57904 6.36034 4.50002 6.55109 4.5 6.75V12H3.75C3.55109 12 3.36034 12.079 3.21969 12.2197C3.07904 12.3603 3.00002 12.5511 3 12.75V21H4.5V13.5H10.5V21H12V4.5H19.5V21H21V3.75C21 3.55109 20.921 3.36034 20.7803 3.21969C20.6397 3.07904 20.4489 3.00002 20.25 3H11.25ZM13.5 6V7.5H15V6H13.5ZM16.5 6V7.5H18V6H16.5ZM6 7.5H10.5V12H6V7.5ZM7.5 9V10.5H9V9H7.5ZM13.5 9V10.5H15V9H13.5ZM16.5 9V10.5H18V9H16.5ZM13.5 12V13.5H15V12H13.5ZM16.5 12V13.5H18V12H16.5ZM6 15V16.5H9V15H6ZM13.5 15V16.5H15V15H13.5ZM16.5 15V16.5H18V15H16.5ZM6 18V19.5H9V18H6ZM13.5 18V19.5H15V18H13.5ZM16.5 18V19.5H18V18H16.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitybuildingsIcnWhite);
export default __webpack_public_path__ + "static/media/citybuildingsIcn-white.2a804546b6774de52dee99dc67530291.svg";
export { ForwardRef as ReactComponent };